export const TIME_ZONES = [
  "UTC -04:00 Puerto Rico",
  "UTC -04:00 U.S. Virgin Islands",

  "UTC -05:00 Connecticut",
  "UTC -05:00 Delaware",
  "UTC -05:00 District of Columbia",
  "UTC -05:00 Georgia",
  "UTC -05:00 Maine",
  "UTC -05:00 Maryland",
  "UTC -05:00 Massachusetts",
  "UTC -05:00 New Hampshire",
  "UTC -05:00 New Jersey",
  "UTC -05:00 New York",
  "UTC -05:00 North Carolina",
  "UTC -05:00 Ohio",
  "UTC -05:00 Pennsylvania",
  "UTC -05:00 Rhode Island",
  "UTC -05:00 South Carolina",
  "UTC -05:00 Vermont",
  "UTC -05:00 Virginia",
  "UTC -05:00 West Virginia",
  "UTC -05:00 Florida",
  "UTC -05:00 Indiana",
  "UTC -05:00 Kentucky",
  "UTC -05:00 Michigan",
  "UTC -05:00 Tennessee",

  "UTC -06:00 Alabama",
  "UTC -06:00 Arkansas",
  "UTC -06:00 Illinois",
  "UTC -06:00 Iowa",
  "UTC -06:00 Louisiana",
  "UTC -06:00 Minnesota",
  "UTC -06:00 Mississippi",
  "UTC -06:00 Missouri",
  "UTC -06:00 Oklahoma",
  "UTC -06:00 Wisconsin",
  "UTC -06:00 Florida",
  "UTC -06:00 Indiana",
  "UTC -06:00 Kansas",
  "UTC -06:00 Kentucky",
  "UTC -06:00 Michigan",
  "UTC -06:00 Nebraska",
  "UTC -06:00 North Dakota",
  "UTC -06:00 South Dakota",
  "UTC -06:00 Tennessee",
  "UTC -06:00 Texas",

  "UTC -07:00 Arizona",
  "UTC -07:00 Colorado",
  "UTC -07:00 Montana",
  "UTC -07:00 New Mexico",
  "UTC -07:00 Utah",
  "UTC -07:00 Wyoming",
  "UTC -07:00 Idaho",
  "UTC -07:00 Kansas",
  "UTC -07:00 Nebraska",
  "UTC -07:00 North Dakota",
  "UTC -07:00 Oregon",
  "UTC -07:00 South Dakota",
  "UTC -07:00 Texas",

  "UTC -08:00 California",

  "UTC -09:00 Alaska",

  "UTC -10:00 Hawaii",
  "UTC +10:00 Guam",
  "UTC +10:00 Northern Mariana Islands",

  "UTC -11:00 American Samoa",

  "UTC -12:00 Baker Island",
  "UTC -12:00 Howland Island",
  "UTC +12:00 Wake Island",
];
